<template>
  <v-app>
    <v-container class="bg-white">
      <v-layout row wrap justify-center>
        <v-flex xs12 md6 style="margin: 0 auto">
          <v-card>
            <v-system-bar dark height="50px" :color="Theme.PINK">
              <v-card-title>優視達官網管理系統</v-card-title>
            </v-system-bar>

            <v-card-text>
              <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation>
                <v-flex xs12 sm12 d-flex>
                  <v-text-field
                      v-model="loginInfo.account"
                      :rules="accountRules"
                      :label="`帳號`"
                      :color="Theme.GREEN"
                      required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 d-flex>
                  <v-text-field
                      v-model="loginInfo.password"
                      :rules="passwordRules"
                      :label="`密碼`"
                      :color="Theme.GREEN"
                      type="password"
                      required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 mt-2>
                  <v-btn color="#0ba7a3" dark style="width: 100%;" :loading="loading"
                         @click.prevent="submitForm()">
                    登入
                  </v-btn>
                </v-flex>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <alert-view/>
    </v-container>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';
import NoticeManager from '../utils/notice_manager';
import common from '@/mixins/common';
import AlertView from "@/components/AlertView";

export default {
  name: 'Login',
  components: {AlertView},
  mixins: [common],
  data() {
    return {
      valid: true,
      loading: false,
      loginInfo: {
        account: '',
        password: '',
      },
      accountRules: [
        v => !!v || '請輸入帳號',
      ],
      passwordRules: [
        v => !!v || '請輸入密碼',
      ],
    };
  },
  created() {
    console.log(`== login ==`)
  },
  methods: {
    ...mapActions(['fetchUserInfo', 'login', 'configUserInfo']),
    submitForm() {
      if (this.$refs.form.validate()) {
        this.loginAction();
      }
    },
    async loginAction() {
      this.loading = true;
      try {
        const response = await this.login({
          account: this.loginInfo.account,
          password: this.loginInfo.password,
        });

        const result = response.data;
        this.loading = false;
        if (result && result.code === 0) {
          const { token } = result.body;
          if (token){
            const user = await this.getUserInfo(token);
            if (user) {
              if (user.enable) {
                user.token = token;
                this.configUserInfo(user);
                NoticeManager.notifyObservers('login_user', user);
                this.$router.push({ path: '/admin/index' });
              } else {
                this.showMessageDialog('錯誤', '帳號未啟用');
              }
            } else {
              this.showMessageDialog('錯誤', '登入失敗');
            }
          } else {
            this.showMessageDialog('錯誤', '登入失敗');
          }
        } else {
          this.showMessageDialog('錯誤', result.message);
        }
      } catch (e) {
        this.showMessageDialog('錯誤', '登入失敗');
      }
    },
    async getUserInfo(token) {
      const response = await this.fetchUserInfo({ token });
      const result = response.data;
      if (result.code === 0) {
        return result.body;
      }
      return null;
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title:title,
        content: content,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
